var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    viewBox: "0 0 320 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25-60h400v300H25z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8 0 0 .8 -20 48)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-60h450v300H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M0 150h450v90H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0-60h450v90H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.764 35.569c-1.71.037-3.378 1.93-3.378 1.93l.148 20.234-6.388 6.692h5.17l-.043 11.602-30.591 41.193-4.522-1.563-7.905 16.861s19.55 12.241 47.926 11.907c31.143-.37 48.064-12.472 48.064-12.472l-8.168-16.644-4 1.74-30.983-40.98-.043-11.948h5.17l-7.037-6.61.042-20.159s-1.752-1.82-3.462-1.783z",
    stroke: "#000",
    strokeWidth: 1.000516
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.43 84.01h-21.153s-7.678-16.177-6.433-27.486c1.267-11.516 7.848-16.963 16.598-17.06 10.345-.115 15.767 5.07 17.405 16.599 1.623 11.424-6.418 27.946-6.418 27.946z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 5.0003060999999995
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.788 122.57c-.346.46-2.882 5.532-2.882 5.532l4.38-.922-1.498-4.61zM190.324 129.14l-4.61 1.498 5.532 2.19-.922-3.688zM192.398 122.685l2.306 6.8 5.648-1.613-1.499-3.228-6.455-1.96zM195.972 131.906l.806 2.766 7.493 1.845-2.997-6.34-5.302 1.729zM204.27 126.143l2.652 6.34 5.648-2.19-1.845-2.767-6.454-1.383zM207.959 134.788l.922 2.42 8.76 1.268-3.688-5.763-5.994 2.075zM216.373 127.987l3.228 5.648 8.183-2.997-.922-2.19-10.489-.46zM221.099 135.71l1.729 2.997 10.143-.346-3.804-5.648-8.068 2.997zM231.819 128.218l2.766 4.725 6.455-3.112-1.73-2.536-7.491.923zM242.423 131.79l-6.455 3.228 1.729 2.766 8.645-1.383-3.92-4.61zM244.498 126.834l3.342 4.15 5.418-4.265-1.845-1.96-6.915 2.075zM254.41 129.024l-5.187 3.92 1.384 2.42 7.146-1.844-3.343-4.496zM261.557 120.84l1.267 1.845-3.573 5.302-3.688-4.726 5.994-2.42zM263.977 125.451l2.19 4.38-4.38 1.499-.346-2.075 2.536-3.804z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/ls.48e104e2a7b56e2a0f87da1c3d6bcc61.svg";
export { ForwardRef as ReactComponent };